module.exports = __webpack_public_path__ + "img/50.9b499bdc.png";